import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";

const NavBar = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: theme.spacing(1),
  left: "50%",
  transform: "translateX(-50%)",
  background: theme.palette.common.white,
  borderRadius: "20px",
  boxShadow: "var(--shadow-light)",
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "calc(100% - 16px)",
  maxWidth: "1200px",
  zIndex: 1000,
  height: "59px",
  [theme.breakpoints.down("sm")]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const LogoIcon = styled(Box)(() => ({
  width: "158px",
  height: "30px",
  cursor: "pointer",
  transition: "opacity 0.2s ease",
  "&:hover": {
    opacity: 0.8,
  },
}));

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = () => {
    if (location.pathname === "/") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      navigate("/");
    }
  };

  return (
    <NavBar>
      <LogoIcon onClick={handleLogoClick}>
        <img
          src="/assets/gtc-logo.svg"
          alt="GTC Logo"
          style={{ width: "100%", height: "100%" }}
        />
      </LogoIcon>
    </NavBar>
  );
}
